// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/components/color-palette/style.scss
// module id = 535
// module chunks = 0 1